var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'home-banner':_vm.isHome},attrs:{"id":"banner"}},[_c('div',{staticClass:"banner-img",style:({'background-image': `url(${_vm.src})`})},[(_vm.isHome)?[_c('div',{staticClass:"focusinfo"}),_c('div',{staticClass:"slant-left"}),_c('div',{staticClass:"slant-right"})]:_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }